<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <div v-if="histories.length > 0">
        <v-simple-table dense v-if="!$vuetify.breakpoint.xs">
            <thead>
                <tr>
                    <th v-if="sensors.length > 1" style="width:100%">センサー</th>
                    <th v-for="alarm in alarmList" :key="alarm.alarmType" class="text-center">{{alarm.text}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(history,index) in histories" :key="index">
                    <td v-if="sensors.length > 1">{{history.sensor.body.name}}</td>
                    <td v-for="alarm in alarmList" :key="alarm.alarmType" class="text-center">
                        <v-chip label small class="grey darken-2 white--text" @click.stop="onClickAlarmNum(history, alarm.alarmType)">
                            <span style="width:100px; text-align:center">
                                {{alarmNum(history, alarm.alarmType)}}
                            </span>
                        </v-chip>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
        <v-simple-table dense v-else>
            <tbody>
                <tr v-for="(history,index) in histories" :key="index">
                    <v-card outlined class="pa-1 ma-1">
                        <table style="width:100%">
                            <tr>
                                <td colspan="2" class="text-subtitle-1">
                                    {{history.sensor.body.name}}
                                </td>
                            </tr>
                            <tr>
                                <td v-for="alarm in alarmList" :key="alarm.alarmType" class="text-center" style="width:80px">
                                    <v-sheet class="grey darken-2 white--text text-caption" rounded @click.stop="onClickAlarmNum(history, alarm.alarmType)">
                                        {{alarm.text}}<br/>
                                        {{alarmNum(history, alarm.alarmType)}}
                                    </v-sheet>
                                </td>
                            </tr>
                        </table>
                    </v-card>
                </tr>
            </tbody>
        </v-simple-table>
    </div>    
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }
    export default {
        props: {
            sensors: null,
            alarmsOnChart: null
        },
        computed: {
            /**
             * 一覧に表示する全データを格納した配列
             */
            histories: function () {
                const list = []

                if (this.sensors == null) return list

                for (var sensor of this.sensors) {

                    const item = {
                        sensor: sensor,
                        numList: {}
                    }

                    for (var alarm of this.alarmList) {
                        const histories = sensor.alarmHistories.filter((v)=>v.alarmType == alarm.alarmType)
                        item.numList[alarm.alarmType] = histories
                    }

                    list.push(item)
                }

                return list
            },
            /**
             * 指定された履歴の中の指定された警報種類の件数
             */
            alarmNum: function () {
                return function (history, alarmType) {
                    return history.numList[alarmType] != null ? history.numList[alarmType].length : 0
                }
            }
        },
        data: function () {
            return {
                alarmList: [
                    {alarmType: 1, text: "上限"},
                    {alarmType: 2, text: "下限"},
                    {alarmType: 3, text: "センサー異常"},
                ],
            }
        },
        methods: {
            onClickAlarmNum: function (history, alarmType) {

                this.alarmsOnChart.splice(0, this.alarmsOnChart.length)

                if (this.alarmNum(history, alarmType) == 0) return

                console.log("onClickAlarmNum", history.numList[alarmType])

                for (var item of history.numList[alarmType]) {
                    const alarmData = {
                        time: item.time,
                        history: item
                    }
                    this.alarmsOnChart.push(alarmData)
                }
            }
        }
    }
</script>
